import { useEffect, useState } from "react";
import { RootState } from "@src/reducers/store";
import { useSelector } from "react-redux";
import { machinesDrBoy } from "./dr-boy-data";
import { machinesImex } from "./imex-data";
import { machinesTT } from "./tt-data";
import { machinesMarandoservice } from "./marandoservice-data";
import { machinesChenHsongSouthAmerica } from "./chen-hsong-south-america-data";

export const useFactoryDashboard = () => {
  const namespace = useSelector(
    (state: RootState) => state?.yourSlice?.authContext?.customerNamespace,
  );
  const [machines, setMachines] = useState<any[]>([]);

  const fetchMachinesForNamespace = (namespace: string | undefined) => {
    let machines: any[] = [];

    switch (namespace) {
      case "62061c5d-479e-4ab0-b5be-7d7aca41fad3":
        machines = machinesDrBoy;
        break;

      case "2d326ad9-0c3c-41f3-9cda-d719eae17df6":
        machines = machinesChenHsongSouthAmerica;
        break;

      case "3b9d096f-4888-4765-b54d-cde3ac35062f":
        machines = machinesImex;
        break;

      case "286bf028-3f4b-432d-a9dc-7c31dd464dc4":
        machines = machinesTT;
        break;

      case "5034c47d-34ab-4f4f-a024-08aa1cbe7b90":
        machines = machinesMarandoservice;
        break;

      case "a06a0feb-c7ac-4988-91ea-37e6d082bf8d":
        machines = [];
        break;

      default:
        machines = [];
    }

    return machines;
  };

  useEffect(() => {
    setMachines(fetchMachinesForNamespace(namespace));
  }, [namespace]);

  return machines;
};
